/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */

import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Map as ImmutableMap } from 'immutable';
import { getTemplateSettings, updateTemplateType } from '../actions/TemplateSettingsBufferActions';
import ChooseTemplatePage from '../components/templateEditor/chooseTemplate/ChooseTemplatePage';
import { THEME_TYPE_SETTING_KEY_PATH } from 'knowledge-content-ui/constants/TemplateEditorConstants';
import { goBack, push } from '../actions/HistoryActions';
import { getCustomizeTemplatePath } from '../routing/utils/internalPaths';
import { jsx as _jsx } from "react/jsx-runtime";
function ChooseTemplate(props) {
  const [isUpdatingTemplateType, setIsUpdatingTemplateType] = useState(false);
  const {
    getTemplateSettings: getTemplateSettingsAction,
    goBack: goBackAction,
    knowledgeBaseId,
    onRouteChange: onRouteChangeAction,
    templateSettings,
    updateTemplateType: updateTemplateTypeAction
  } = props;
  useEffect(() => {
    if (knowledgeBaseId) {
      getTemplateSettingsAction(knowledgeBaseId);
    }
  }, [getTemplateSettingsAction, knowledgeBaseId]);
  const handleChooseTemplateClick = templateType => {
    setIsUpdatingTemplateType(true);
    updateTemplateTypeAction(knowledgeBaseId, templateSettings, templateType).then(() => onRouteChangeAction(getCustomizeTemplatePath()));
  };
  const currentTemplate = templateSettings.getIn(THEME_TYPE_SETTING_KEY_PATH);
  return /*#__PURE__*/_jsx(ChooseTemplatePage, {
    currentTemplate: currentTemplate,
    onBackClick: goBackAction,
    onChooseTemplateClick: handleChooseTemplateClick,
    showLoadingOverlay: isUpdatingTemplateType
  });
}
ChooseTemplate.propTypes = {
  getTemplateSettings: PropTypes.func.isRequired,
  goBack: PropTypes.func.isRequired,
  knowledgeBaseId: PropTypes.number,
  onRouteChange: PropTypes.func.isRequired,
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'typeof Map' is not assignable to... Remove this comment to see the full error message
  templateSettings: PropTypes.instanceOf(ImmutableMap).isRequired,
  updateTemplateType: PropTypes.func.isRequired
};
const mapStateToProps = state => {
  const {
    knowledgeBaseDetails: {
      knowledgeBase: {
        id: knowledgeBaseId
      }
    },
    templateSettings
  } = state;
  return {
    knowledgeBaseId,
    templateSettings
  };
};
const mapDispatchToProps = {
  getTemplateSettings,
  goBack,
  onRouteChange: push,
  updateTemplateType
};
export default connect(mapStateToProps, mapDispatchToProps)(ChooseTemplate);